<template>
  <div style="height: 100%;" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading="loading" element-loading-text="加载中，请耐心等待。">
    <div style="max-height: calc(100% - 50px);overflow-y: auto">
      <div style="height: 50px;font-size: 20px;color: #FFFFFF;text-align: center" v-if="showTable.length === 0"><span>暂无数据</span></div>
      <div class="box-item" v-for="item in showTable" :key="item.id">
        <div class="in-item">
          <div class="line-top">
            <div class="all-three-point" style="margin: 0 20px;height: 50px;line-height: 50px;font-size: 22px" :title="item.device.build_name + '/' + item.device.floor_name + '/' + item.device.home_room">
              <span style="font-size: 14px">{{item.device.build_name}}</span>
              <span>/{{item.device.floor_name}}/{{item.device.home_room}}</span>
            </div>
            <div style="margin: 0 20px;height: 20px;line-height: 20px;font-size: 16px"><span>{{getAType(item)}}</span></div>
          </div>
          <div style="margin: 10px 20px;color: white">
            <div style="height: 140px">
              <div>
                <div style="height: 35px;font-size: 14px">
                  <span>设备类型：</span>
                  <img v-if="item.device && (item.alarmtype !== 'birthday' || item.alarmtype !== 'phonein')" style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImg(item.device.devicetype)">
                  <span v-if="item.device && (item.alarmtype !== 'birthday' || item.alarmtype !== 'phonein')">{{getDeviceType(item.device.devicetype)}}</span>
                  <span style="font-size: 12px" v-if="item.subdevice">/ {{item.subdevice.sub_name}}</span>
                </div>
                <div style="height: 35px;font-size: 14px">
                  <span>设备编号：</span><span v-if="item.device">{{item.device.deviceid}}</span>
                </div>
                <div style="height: 35px;font-size: 14px">
                  <span>报警位置：</span>
                  <span v-if="item.sub_deviceid && item.subdevice && item.subdevice.remark !== ''">{{item.subdevice.remark}}</span>
                  <span v-else>
                    <span v-if="item.device">{{item.device.h_installlocation}}</span>
                    <span v-if="item.device">{{item.device.o_installlocation}}</span>
                  </span>
                </div>
                <div style="height: 35px;font-size: 14px">
                  <span>服务对象：<span v-if="item.device">{{item.device.p_name}}</span></span>
                </div>
              </div>
            </div>
            <div style="height: 40px">
              <div style="float: left;width: calc(100% - 100px);">
                <div style="height: 20px;line-height: 20px;font-size: 14px"><span>{{ item.time }}</span></div>
                <div style="color: #FFFFFF" v-if="item.handleuesrname === '未处理' || item.handleuesrname === '继续处理'"></div>
                <div style="color: #e5a015" v-else>
                  <img src="../../assets/handlealarm/event_icon_major.png" style="vertical-align: middle;width: 16px">
                  <strong>{{item.handleuesrname}}</strong>
                </div>
              </div>
              <div :style="{cursor: item.buttondisable ? 'notAllowed' : 'pointer'}" class="btn-handle" @click="handleChangeNew(item)"><span>现在处理</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom class="page-style" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[12, 24, 36, 96]" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog top="5vh" :visible.sync="handleAlarmShow" v-if="handleAlarmShow" width="900px"
               :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" class="alarm-detail">
      <open-handle-alarm :handleAlarmRow="changeRow"  @getFatherHandle="getFatherHandle"></open-handle-alarm>
    </el-dialog>
  </div>
</template>

<script>
import {queryunhanlealarm} from '../../api/handlealarm'
import {querydevicebydids, querysubdevice} from '../../api/device'
import {sendSub} from '../../mq'
import openHandleAlarm from './components/openHandleAlarm'
export default {
  name: 'eventMonitor',
  components: {openHandleAlarm},
  data () {
    return {
      loading: false,
      dids: [],
      devices: [],
      isDevice: true,
      subdids: [],
      subdevices: [],
      issubDevice: true,
      tableData: [],
      showTable: [],
      pageSize: 12,
      currentPage: 1,
      totalCells: 0,
      imgIconAlarm: [],
      imgIcon: [],
      handleAlarmShow: false,
      changeRow: {
        isPhonein: false,
        oldPerson: '',
        row: {},
        types: [],
        supplierorg: [],
        projects: [],
        frequencys: [],
        typeOrg: [],
        orgcommunitys: [],
        alarmOrder: '' // 转让订单的信息
      }
    }
  },
  created () {
    this.golobleObject.getHandleInfo = this.changeShow
    this.golobleObject.updateTableAlarm = this.mqttHandle
    this.imgIconAlarm = this.getImgArr.getImgIconAlarm()
    this.imgIcon = this.getImgArr.getImgIconDevice()
    this.mqttHandleAlarm()
  },
  methods: {
    // 表格数据
    mqttHandleAlarm () {
      this.loading = true
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryunhanlealarm(params).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.alarms
        let oldDids = this.dids.length
        let oldSub = this.subdids.length
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.dids.indexOf(this.tableData[i].did) === -1) {
            this.dids.push(this.tableData[i].did)
          }
          if (this.subdids.indexOf(this.tableData[i].sub_deviceid) === -1) {
            this.subdids.push(this.tableData[i].sub_deviceid)
          }
        }
        if (oldDids === this.dids.length) {
          this.isDevice = false
        } else {
          this.isDevice = true
        }
        if (oldSub === this.subdids.length) {
          this.issubDevice = false
        } else {
          this.issubDevice = true
        }
        this.getDevices()
      }).catch(() => {
        this.loading = false
      })
    },
    // 主设备
    getDevices () {
      if (this.isDevice) {
        let data = {
          dids: this.dids
        }
        querydevicebydids(data).then(res => {
          this.devices = this.devices.concat(res.data.devices)
          this.getSubDevices()
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.getSubDevices()
      }
    },
    // 子设备
    getSubDevices () {
      if (this.issubDevice) {
        let data = {
          sub_deviceid: this.subdids
        }
        querysubdevice(data).then(res => {
          this.subdevices = res.data.subdevices
          this.getDeviceTable()
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.getDeviceTable()
      }
    },
    getDeviceTable () {
      // console.log(777)
      const tempList = this.tableData
      this.tableData = []
      for (let i = 0; i < tempList.length; i++) {
        for (let j = 0; j < this.devices.length; j++) {
          if (tempList[i].did === this.devices[j].id) {
            tempList[i].device = this.devices[j]
          }
        }
        for (let j = 0; j < this.subdevices.length; j++) {
          if (tempList[i].sub_deviceid === this.subdevices[j].sub_deviceid && tempList[i].did === this.subdevices[j].main_did) {
            tempList[i].subdevice = this.subdevices[j]
          }
        }
      }
      this.tableData = tempList
      this.changeShow()
    },
    changeShow () {
      // console.log(999)
      this.showTable = []
      const handle = this.store2.state.other.isHandle
      let handleIDList = []
      for (let i = 0; i < handle.length; i++) {
        const arr = handle[i]
        if (handleIDList.indexOf(parseInt(arr.id)) === -1) {
          handleIDList.push(parseInt(arr.id))
        }
      }
      const tempList = this.tableData
      this.tableData = []
      for (let i = 0; i < tempList.length; i++) {
        const alarmObj = tempList[i]
        alarmObj.buttondisable = false
        alarmObj.handleuesrname = '未处理'
        if (alarmObj.prehandle > 0) {
          alarmObj.handleuesrname = '继续处理'
        }
        if (handleIDList.indexOf(alarmObj.id) > -1) {
          for (let ii = 0; ii < handle.length; ii++) {
            const usernameObj = handle[ii]
            if (usernameObj.id === alarmObj.id) {
              alarmObj.buttondisable = true
              alarmObj.handleuesrname = usernameObj.name + '正在处理'
            } else {
              alarmObj.buttondisable = false
            }
          }
        }
        this.tableData.push(alarmObj)
      }
      this.showTable = this.tableData
      // setTimeout(() => {
      //   this.showTable = this.tableData
      // }, 50)
      this.loading = false
      this.$forceUpdate()
      console.log('endlist', this.tableData)
    },
    // mqtt收到报警
    mqttHandle () {
      if (this.showTable.length === 1 && this.currentPage !== 1) {
        this.currentPage -= 1
      }
      this.mqttHandleAlarm()
    },
    getTypeImgAlarm (type) {
      let num = this.commonType.getAlarmTypeIcon(type)
      return this.imgIconAlarm[num].imgUrl
    },
    getAType (row) {
      return this.commonType.getAlarmType(row.alarmtype)
    },
    getTypeImg (type) {
      let url = this.imgIcon[0].imgUrl
      for (let i = 0; i < this.imgIcon.length; i++) {
        if (type === this.imgIcon[i].dtype) {
          url = this.imgIcon[i].imgUrl
        }
      }
      return url
    },
    getDeviceType (type) {
      if (type === 700) {
        return '智能网关'
      }
      return this.commonType.getDeviceType(type)
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else {
        if (row.h_phone !== '') {
          return row.h_phone
        } else {
          return row.p_phone
        }
      }
    },
    handleChangeNew (row) {
      let mqtts = this.$store.state.user.mqtts
      this.changeRow.alarmOrder = ''
      // console.log(row)
      let name = this.$store.state.user.personname
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const date = new Date().format('yyyy-MM-dd hh:mm:ss')
      let jobnum = this.$store.state.user.syspersonjobnum
      let dohandle = {id: row.id, name: name, time: date, jobnum: jobnum}
      sendSub('/handlealarm' + mqtts[0], JSON.stringify(dohandle))
      if (row.alarmtype !== 'phonein') {
        this.changeRow.row = row
        this.handleAlarmShow = true
      } else {
        // console.log(11, this.changeRow)
        let obj = {
          alarmRow: row,
          types: this.changeRow.types,
          supplierorg: this.changeRow.supplierorg,
          typeOrg: this.changeRow.typeOrg,
          projects: this.changeRow.projects,
          orgcommunitys: this.changeRow.orgcommunitys
        }
        this.golobleObject.openPhoneCall(obj)
      }
    },
    getFatherHandle (obj) {
      if (obj.type === 'close') {
        this.handleAlarmShow = false
      } else if (obj.type === 'send') {
        this.mqttHandleAlarm()
        this.handleAlarmShow = false
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.mqttHandleAlarm()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.mqttHandleAlarm()
    }
  }
}
</script>

<style scoped>
.box-item{
  float: left;
  width: 25%;
}
.in-item{
  margin: 10px;
  font-family: PingFang-SC-Regular;
  letter-spacing: 1px;
  border-radius: 5px 5px 0px 0px;
  border: solid 1px #ff3535;
  color: black;
  flex: 0 0 24%;
  height: 280px;
}
.line-top{
  height: 80px;
  background-color: rgba(255, 0, 0, 0.38);
  border-radius: 5px 5px 0px 0px;
  color: white;
}
.btn-handle{
  width: 100px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  background-color: #e93e3e;
  border-radius: 5px;
  float: right;
  font-size: 14px;
  border: none;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/eventMonitor.vue